import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { RouterModule } from '@angular/router';
import { TranslateModule, TranslatePipe, TranslateService } from '@ngx-translate/core';
import { Language } from '../../interfaces/language.interface';
import { LanguageStateService } from '../../services/language-state.service';

@Component({
  selector: 'app-header',
  imports: [
    CommonModule,
    RouterModule,
    MatButtonModule,
    MatMenuModule,
    MatIconModule,
    TranslatePipe,
    TranslateModule,
  ],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
  private readonly translate = inject(TranslateService);
  private readonly languageService = inject(LanguageStateService);

  languages = this.languageService.languages;

  readonly actualLanguage = this.languageService.activeLanguage;

  constructor() {}

  changeLanguage(lang: Language) {
    this.translate.use(lang.code);
    this.languageService.setActiveCode(lang.code);
  }

  goHome() {
    globalThis.location.href = '/';
  }
}
